module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-detail",
    attrs: {
      "id": ("product_sku__" + (_vm.product.sku))
    }
  }, [(_vm.title) ? _c('h1', {
    staticClass: "page-title text-center"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container pd-sm-0"
  }, [(_vm.ready) ? _c('div', [_c('product-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.product.sku),
      expression: "product.sku"
    }],
    attrs: {
      "extraClasses": "product--inline",
      "product": _vm.product,
      "initialQuantity": 1,
      "cartMode": false,
      "showAttributes": true,
      "useCarousel": true,
      "titleAsLink": false,
      "showTimeBeforeAvailable": true
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  }), _vm._v(" "), (_vm.product.notice) ? _c('div', {
    staticClass: "alert alert--danger text-left"
  }, [_c('strong', [_vm._v("หมายเหตุ")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.notice)
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.ready) ? _c('div', [_c('loader')], 1) : _vm._e()]), _vm._v(" "), _c('banner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f20e9ef","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetail.vue
// module id = 1119
// module chunks = 0